if (!window.customElements.get("component-media-slider")) {
  class ProductsmainSlider extends HTMLElement {

    constructor() {
      super();

      this.selectors = {
        swiper: "swiper-container",
        prevEl: ".custom-prev-button",
        nextEl: ".custom-next-button"
      }

      this.slider = this.querySelector(this.selectors.swiper);
      this.buttonPrev = this.querySelector(this.selectors.prevEl);
      this.buttonNext = this.querySelector(this.selectors.nextEl);
      this.initSlider();
    }

    initSlider() {
      const swiperParams = {
        slidesPerView: "auto",
        preloadImages: false,
        lazy: true,
        spacebetween: "8",
        breakpoints: {
          640: {
            slidesPerView: 1,
          },
          990: {
            slidesPerView: 8,
          }
        },
        navigation: {
          nextEl: this.buttonNext,
          prevEl: this.buttonPrev
        },
        on: {
          init() {
          }
        },
      };

      Object.assign(this.slider, swiperParams);

      this.slider.initialize();

    }
}

customElements.define('component-thumb-slider', ProductsmainSlider);

class ProductsmainSlider2 extends HTMLElement {

  constructor() {
    super();

    this.selectors = {
      swiper: "swiper-container",
      prevEl: ".custom-prev-button",
      nextEl: ".custom-next-button"
    }

    this.slider = this.querySelector(this.selectors.swiper);
    this.buttonPrev = this.querySelector(this.selectors.prevEl);
    this.buttonNext = this.querySelector(this.selectors.nextEl);
    this.initSlider();
  }

  initSlider() {
    const swiperParams = {
      slidesPerView: "auto",
      preloadImages: false,
      lazy: true,
      spacebetween: "0",
      thumbs: {
        swiper: '.swipper__thumb',
      },
      pagination: {
        type: "fraction",
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        990: {
          slidesPerView: 1,
        }
      },
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev
      },
      on: {
        init() {
        }
      },
    };

    Object.assign(this.slider, swiperParams);

    this.slider.initialize();

  }
}

customElements.define('component-media-slider', ProductsmainSlider2);
}
